import React from "react";
import PropTypes from 'prop-types';

import Icon from "@material-ui/core/Icon";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import Hidden from '@material-ui/core/Hidden';


import { matchPath } from './router';
import { withStyles } from "@material-ui/core";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import * as classnames from 'classnames';


const Item = ({ text, subtitle, icon, iconCode, accessoryIcon, classes, exact, strict, ...props }) => {
    const usedClasses = (props.className || '').split(' ')
        // .map(v => classes[v])
        .filter(v => v !== undefined)
        .join(' ');

    return (
        <ListItem
            selected={matchPath(props.href, { exact, strict })}
            button
            {...props}
            className={usedClasses}
        >
            <ListItemIcon>
                <Tooltip title={text}>
                    {iconCode ? ( <span className={classnames("menuIconCode", iconCode)}> </span>) : (<Icon>{icon}</Icon>)}
                </Tooltip>
            </ListItemIcon>
            <ListItemText
                className={classes.hideIcon}
                // classes={{"primary": classes.itemText}}
                primary={(
                    <EllipsisWithTooltip>{text}</EllipsisWithTooltip>)}
                    {...(subtitle && {secondary : <EllipsisWithTooltip>{subtitle}</EllipsisWithTooltip>})}
            />
            <span className={classes.hideIcon}>
                {accessoryIcon && (
                    <Icon>{accessoryIcon}</Icon>
                )}
            </span>
        </ListItem>
    );
};

Item.propTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    accessoryIcon: PropTypes.string,
    exact: PropTypes.bool,
    strict: PropTypes.bool,
};

Item.defaultProps = {
    accessoryIcon: null,
    exact: false,
    strict: false,
};

const styles = theme => ({
    itemText: {
        ...theme.helpers.oneLiner,
    },
    bottom: {
        marginTop: 'auto',
    },
    hideIcon: {
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    }
});

export default withStyles(styles)(Item);
